module.exports = __webpack_public_path__ + "img/2-left.72855014.svg";